import React, { useEffect, useState } from "react";
import { api } from "../../../App";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";
import { Autocomplete, TextField, Typography } from "@mui/material";

export default function MultiSelectInput(props) {
  //const { loadOptionsFromUrl, optionsUrl } = props;
  const {
    label,
    id,
    readOnly,
    placeholderText,
    required,
    options,
    optionsUrl,
    loadOptionsFromUrl,
    onChange,
    value,
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
    itemIndex,
    level,
    messageTime,
  } = props;

  const [items, setItems] = useState(loadOptionsFromUrl ? [] : options);
  const [internalValue, setInternalValue] = useState();
  const [inputValue, setInputValue] = useState("");

  const loadData = () => {
    const optionsLoader = async () =>
      await api.getByUrl(optionsUrl).then(
        (response) => {
          setItems(response.data);
          setInternalValue(
            response.data.filter((item) => value.includes(item.value))
          );
        },
        (error) => {
          console.log(
            `An error occurred loading objects from ${optionsUrl} -> ${error.status}`
          );
        }
      );
    optionsLoader().then(
      () => {
        if (readOnly) {
          handleSubComponentLoaded(
            getComponentRef(
              "SingleSelectInput [From API Lookup]",
              itemIndex,
              level,
              messageTime
            ),
            true
          );
        }
      },
      (error) => console.log(`An error occurred loading options -> ${error}`)
    );
  };

  const handleOnChange = (evt, values) => {
    setInternalValue(values);
    onChange(
      id,
      values.map((item) => item.value)
    );
  };

  useEffect(() => {
    if (loadOptionsFromUrl === false) {
      if (readOnly) {
        handleSubComponentLoaded(
          getComponentRef(
            "SingleSelectInput [From Option List]",
            itemIndex,
            level,
            messageTime
          ),
          true
        );
      }
      return;
    }
    loadData();
  }, []);

  const renderReadOnly = () => {
    if (internalValue === undefined) {
      return false;
    }

    return (
      <>
        <Typography variant="subtitle1" fontWeight={"bold"}>
          {label}
        </Typography>
        <TextField
          variant="standard"
          value={internalValue.map((item) => item.name).join(", ")}
          disabled
          fullWidth
        />
      </>
    );
  };

  const render = () => {
    return (
      <>
        <Autocomplete
          options={items}
          value={internalValue}
          onChange={handleOnChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={label}
              value={inputValue}
              onChange={(event) => setInputValue(event.target.value)}
            />
          )}
          disabled={readOnly}
          autoHighlight
          freeSolo
          forcePopupIcon
          multiple
        />
      </>
    );
  };

  return readOnly ? renderReadOnly() : render();
}
